export const MAINTENANCE_ALERT_RULES_UPDATED_EVENT =
  "maintenance-alert-rules-updated";
